export const documentValidatorTranslations = {
    pt: {
        hero: {
            badge: "Validador de Documentos",
            title: "Valide CPF e CNPJ",
            titleHighlight: "gratuitamente.",
            description: "Verifique se documentos brasileiros são válidos online"
        },
        input: {
            placeholder: "Digite o CPF ou CNPJ (com ou sem pontuação)",
            label: "Digite o documento"
        },
        buttons: {
            validate: "Validar",
            clear: "Limpar"
        },
        result: {
            title: "Resultado da Validação",
            valid: "Válido",
            invalid: "Inválido",
            typeLabel: "Tipo detectado:"
        }
    },
    en: {
        hero: {
            badge: "Document Validator",
            title: "Validate CPF and CNPJ",
            titleHighlight: "for free.",
            description: "Check if Brazilian documents are valid online"
        },
        input: {
            placeholder: "Enter CPF or CNPJ (with or without punctuation)",
            label: "Enter the document"
        },
        buttons: {
            validate: "Validate",
            clear: "Clear"
        },
        result: {
            title: "Validation Result",
            valid: "Valid",
            invalid: "Invalid",
            typeLabel: "Detected type:"
        }
    }
};
